import React, { useMemo } from 'react'
import { Box, Chip, Divider, Typography } from "@mui/material"
import { ButtonLoadingSeeker, IconSeeker, ModalSeeker } from "@ui-seeker/core"
import { originalUserData, showSaveConfirm, userPayload } from "Pages/Admin/Users/@signals"
import useCreateUsersModal from "Pages/Admin/Users/@hooks/useCreateModal"
import { computeDiff } from "Pages/Admin/Users/@utils/diff"

export default function ConfirmSaveModal() {
	const { onSubmitModal, isEditLoading } = useCreateUsersModal()

	const changes = useMemo(
		() => computeDiff(originalUserData.value, userPayload.value),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[showSaveConfirm.value]
	)

	if (!showSaveConfirm.value) return null

	return <ModalSeeker
		hideActions
		title="Confirm changes"
		isOpen={showSaveConfirm.value}
		controller={() => { showSaveConfirm.value = false }}
	>
		<Box sx={{ minWidth: 400, maxWidth: 600 }}>
			{changes.length === 0
				? <Typography color="text.secondary" sx={{ mb: 2 }}>No changes detected.</Typography>
				: <>
					<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
						The following changes will be saved:
					</Typography>
					<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 2 }}>
						{changes.map(({ type, label, oldVal, newVal, added, removed }) => (
							<Box key={label}>
								<Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>{label}</Typography>
								{type === 'scalar' &&
									<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', pl: 1 }}>
										<Typography variant="body2" color="error.main" sx={{ textDecoration: 'line-through' }}>{oldVal}</Typography>
										<IconSeeker icon="arrow-right" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}/>
										<Typography variant="body2" color="success.main">{newVal}</Typography>
									</Box>
								}
								{type === 'password' &&
									<Typography variant="body2" color="warning.main" sx={{ pl: 1 }}>Password updated</Typography>
								}
								{type === 'array' &&
									<Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', pl: 1 }}>
										{added.map(item => (
											<Chip key={`add-${item}`} label={`+ ${item}`} size="small" color="success" variant="outlined"/>
										))}
										{removed.map(item => (
											<Chip key={`rem-${item}`} label={`- ${item}`} size="small" color="error" variant="outlined"/>
										))}
									</Box>
								}
							</Box>
						))}
					</Box>
				</>
			}
			<Divider sx={{ mb: 2 }}/>
			<Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
				<ButtonLoadingSeeker
					startIcon={<IconSeeker icon="xmark"/>}
					onClick={() => { showSaveConfirm.value = false }}
				>
					Cancel
				</ButtonLoadingSeeker>
				<ButtonLoadingSeeker
					startIcon={<IconSeeker icon="check"/>}
					onClick={onSubmitModal}
					loading={isEditLoading}
				>
					Confirm & Save
				</ButtonLoadingSeeker>
			</Box>
		</Box>
	</ModalSeeker>
}